// Styles
import "./VCalendarCategory.sass";

// Types
import { VNode } from "vue";

// Mixins
import VCalendarDaily from "./VCalendarDaily";

// Util
import { convertToUnit, getSlot } from "./util/helpers";
import { CalendarCategory, CalendarTimestamp } from "./Types/lib";
import props from "./util/props";
import { getParsedWorkers } from "./util/parser";

/* @vue/component */
export default VCalendarDaily.extend({
    name: "e-calendar-category",

    props: { ...props.category, ...props.category.workers },

    data: () => ({
        startDrag: false,
        dragFromCategory: null,
        eventId: 0,
    }),

    computed: {
        // eslint-disable-next-line @typescript-eslint/ban-types
        classes(): object {
            return {
                "v-calendar-daily": true,
                "v-calendar-category": true,
                ...this.$props.themeClasses,
            };
        },
        parsedCategories(): CalendarCategory[] {
            //this.$props.workers
            return getParsedWorkers(this.$props.workers);
            //return getParsedCategories(this.categories as CalendarCategory[], this.categoryText);
        },
    },
    methods: {
        genDayHeader(day: CalendarTimestamp, index: number): VNode[] {
            const data = {
                staticClass: "v-calendar-category__columns",
            };
            const scope = {
                week: this.days,
                ...day,
                index,
            };
            const children = this.$props.workers.map((category: any) => {
                //return this.genDayHeaderCategory(day, this.getCategoryScope(scope, category['name']), category);
                if (category["status"]["id"] === 1 || category["status"]["id"] === 3
                )
                    return this.genDayHeaderCategory(day, this.getCategoryScope(scope, category), category);
            });

            /*const children = this.parsedCategories.map((category) => {
                return this.genDayHeaderCategory(day, this.getCategoryScope(scope, category), category);
            });*/

            return [this.$createElement("div", data, children)];
        },
        getCategoryScope(scope: any, category: CalendarCategory) {
            console.log('getCategoryScope')
            /*const cat =
                typeof category === "object" && category && category.categoryName === this.categoryForInvalid
                    ? null
                    : category;*/
            return {
                ...scope,
                category: category,
            };
        },
        genDayHeaderCategory(day: CalendarTimestamp, scope: any, category?: any): VNode {
            //const category = typeof scope.category === "object" ? scope.category : scope.category;
            //const scopeData = scope
            scope["id"] = category["id"];
            return this.$createElement(
                "div",
                {
                    staticClass: "v-calendar-category__column-header",
                    on: this.getDefaultMouseEventHandlers(":day-category", (e: any) => {
                        return this.getCategoryScope(this.getSlotScope(day), scope.category);
                    }),
                },
                [
                    //getSlot(this, "category", scope) || this.genDayHeaderCategoryTitle(headerTitle),
                    //getSlot(this, "category", scope) || this.genDayHeaderCategoryTitle(scopeData, category),
                    this.genDayHeaderCategoryTitle(scope["category"]["fio"], category["id"]),
                    getSlot(this, "day-header", scope),
                ],
            );
        },
        genDayHeaderCategoryTitle(caption: string, category: number) {
            //categoryData['id']= category['id'];
            const that = this;
            return this.$createElement(
                "div",
                {
                    staticClass: "v-calendar-category__category",
                },
                [
                    this.$createElement("a-row", [
                        this.$createElement("a-col", { attrs: { span: 4 } }, [
                            this.$createElement("a-avatar", { props: { icon: "user", size: "large" } }),
                        ]),
                        this.$createElement("a-col", { attrs: { span: 16 } }, [this.$createElement("p", caption)]),
                        this.$createElement("a-col", { attrs: { span: 4 } }, [
                            /*this.$createElement("a-button", {
                                props: {
                                    type: "primary",
                                    shape: "circle",
                                    icon: "plus",
                                },
                                on: {
                                    click: function () {
                                        that.$emit("calendar_categoryAdd", category);
                                    },
                                },
                            })*/,
                        ]),
                    ]),
                ],
            );
        },

        genDays(): VNode[] {
            const days: VNode[] = [];
            this.days.forEach((d, j) => {
                const day = new Array(this.parsedCategories.length || 1);

                day.fill(d);
                console.log('*******genDays********')
                days.push(...day.map((v, i) => this.genDay(v, j, i)));
            });
            return days;
        },

        genDay(day: CalendarTimestamp, index: number, categoryIndex: number): VNode {
            //const category = this.parsedCategories[categoryIndex];
            const categoryWorkersData = this.$props.workers[categoryIndex];
            console.log('genDay')
            return this.$createElement(
                "div",
                {
                    key: day.date + "-" + categoryIndex,
                    staticClass: "v-calendar-daily__day",
                    class: this.getRelativeClasses(day),
                    on: this.getDefaultMouseEventHandlers(":time", (e) => {
                        return this.getSlotScope(this.getTimestampAtEvent(e, day));
                    }),
                },
                [...this.genDayIntervals(index, categoryWorkersData), ...this.genDayBody(day, categoryWorkersData)],
            );
        },
        genDayIntervals(index: number, category: any): VNode[] {
            //TODO::заменить category['name'] на category['id']
            return this.intervals[index].map((v) => this.genDayInterval(v, category["name"]));
        },

        genDayInterval(interval: CalendarTimestamp, category: CalendarCategory): VNode {
            const height: string | undefined = convertToUnit(this.intervalHeight);
            const styler = this.intervalStyle || this.intervalStyleDefault;

            const data = {
                key: interval.time,
                staticClass: "v-calendar-daily__day-interval",
                style: {
                    height,

                    ...styler({ ...interval, category }),
                },
            };

            const children = getSlot(this, "interval", () =>
                this.getCategoryScope(this.getSlotScope(interval), category),
            );

            return this.$createElement("div", data, children);
        },
        genDayBody(day: CalendarTimestamp, category: any): VNode[] {
            console.log('genDayBody 1')
            const data = {
                staticClass: "v-calendar-category__columns",
            };

            console.log('genDayBody 2')
            const children = [this.genDayBodyCategory(day, category)];

            console.log('children', children)

            return [this.$createElement("div", data, children)];
        },

        genDayBodyCategory(day: CalendarTimestamp, category: any): VNode {
            console.log('genDayBodyCategory')
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const that = this;
            const attrs = {
                "data-category": Number(category.id),
            };

            const data = {
                staticClass: "v-calendar-category__column",
                attrs: attrs,

                on: {
                    click: (e: MouseEvent) => {
                        console.log('inside click')
                        e.preventDefault();
                        console.log('before emit inside click')
                        that.$emit(
                            "calendar_AddRecord",
                            this.getCategoryScope(this.getSlotScope(this.getTimestampAtEvent(e, day)), category),
                        );
                        console.log('after emit inside click')
                    },

                    dragstart: (e: MouseEvent) => {
                        console.log('inside dragstart')
                        //TODO::привязать visitId к Day
                        //const test = this.getTimestampAtEvent(e, day);

                        //e.preventDefault();


                        this.dragFromCategory = category.id;
                        const target = e.target as HTMLElement;

                        if (target.tagName === "A" || target.tagName === "DIV") {

                            this.startDrag = true;
                            if (target.dataset && target.dataset["eventId"]) {
                                this.eventId = Number(target.dataset["eventId"]);
                            }

                            if(!this.eventId && target.children.length) {
                                this.eventId = Number(target.children[0].getAttribute('data-event-id'));
                            }
                        }
                        that.$emit("calendar_MoveEventCategoryStart", e );



                    },
                    mousedown:(e: MouseEvent) =>{ // 111
                        console.log('inside mousedown')

                        console.log('---------------------------------- <')
                        console.log(e);
                        console.log(this.eventId);
                        console.log('---------------------------------- >')

                    },
                    //dragend:(e: MouseEvent) =>{},

                    mouseup: (e: MouseEvent) => {
                        console.log('inside mouseup')

                        if (that.startDrag) {
                            console.log('inside mouseup startDrag')

                            const element = (e.target as HTMLElement)

                            console.log('---------------------------------- <')
                            console.log(element);
                            console.log(this.eventId);
                            console.log('---------------------------------- >')

                            if (element &&  element.className === 'v-calendar-category__column') {
                                console.log('inside mouseup startDrag category__column')
                                that.$emit("calendar_MoveRecord", {
                                    event: {
                                        id: this.eventId,
                                        data: e,
                                    },
                                    category: {
                                        toCategory: Number(category.id),
                                        fromCategory: Number(this.dragFromCategory),
                                    },
                                    times: {
                                        time: this.getTimestampAtEvent(e, day),
                                        day: day,
                                    },
                                });
                            }
                            that.startDrag = false;
                            that.dragFromCategory = null;
                            e.preventDefault();


                        }
                    },
                },

                /*on: this.getDefaultMouseEventHandlers(":time-category", (e) => {
                    //TODO::добавил prevent
                    return this.getCategoryScope(this.getSlotScope(this.getTimestampAtEvent(e, day)), category);
                }),*/
            };
            const children = getSlot(this, "day-body", () =>
                this.getCategoryScope(this.getSlotScope(day), category["name"]),
            );
            return this.$createElement("div", data, children);
        },
    },
});
